<form style="width: 100%">
  <mat-form-field style="width: 100%">
    <mat-label style="color: #7c7c7c;">{{ label }}</mat-label>
    <input matInput (change)="change($event)" />
  </mat-form-field>
</form>
